import { pxToEm, embedMediaQuery } from 'utils/styles/style_helpers';


/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// IMAGE API STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
    unsplash_attribution: {
        position: 'absolute',
        height: '23px',
        bottom: 0,
        overflow: 'hidden',
        zIndex: '1000',
        opacity: '0.75',
        background: theme.color.primary.medium.swatch,
        textAlign: 'center',
        '& a': {
            color: "#ffffff",
            fontSize: '10px'
        },
        '& a:hover': {
            textDecoration: 'underline'
        },
        '@media (max-width: 1500px)':{
            '& a': {
                fontSize: '0.6vw'
            },
        }  
    }
});
